import { render, staticRenderFns } from "./platcontractprocess-add-or-update.vue?vue&type=template&id=0d2ba52d&"
import script from "./platcontractprocess-add-or-update.vue?vue&type=script&lang=js&"
export * from "./platcontractprocess-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports